module.exports = __webpack_public_path__ + "media/images/icons/map/marker-outgoing-54x54-570bec99d2892a3bff4a36cf3aecf502.png";